import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Button} from 'react-bootstrap';
import axios from 'axios';
import ContractItemsHistoryModal from "./ContractItemsHistoryModal";

export default class ContractItemsHistory extends Component {
    constructor() {
        super();

        this.state = {
            item_id: 0,
            items: []
        };

        this.closeModal = this.closeModal.bind(this);
        this.viewDetails = this.viewDetails.bind(this);
    }

    componentWillMount() {
        this.getHistory();
    }

    getHistory() {
        axios
            .get("/contracts/ajax/manage_contracts/" + this.props.contractId + "/items_history")
            .then((response) => {
                this.setState({
                    items: response.data
                });
            });
    }

    closeModal() {
        this.setState({show_modal: false}, () => {
            this.getHistory();
        });
    }

    viewDetails(id) {
        this.setState({
            show_modal: true,
            item_id: id
        });
    }

    render() {
        let rows = [];
        let items = this.state.items;

        if (items.length > 0) {
            for (let key in items) {
                let item = items[key];

                if (items.hasOwnProperty(key)) {
                    rows.push(
                        <div className="like-row" key={item.id}>
                            <div className="description like-cell">
                                <div className="cell-label">{window.__js_contracts.item_description}</div>
                                <div className="cell-value">{item.description}</div>
                            </div>

                            <div className="measurement-unit like-cell">
                                <div className="cell-label">{window.__js_contracts.measurement_unit}</div>
                                <div className="cell-value">{item.measurement_unit_name}</div>
                            </div>

                            <div className="quantity like-cell">
                                <div className="cell-label">{window.__js_contracts.total_quantity}</div>
                                <div className="cell-value">{item.quantity_formatted}</div>
                            </div>

                            <div className="received-quantity like-cell">
                                <div className="cell-label">{window.__js_contracts.received_quantity}</div>
                                <div className="cell-value">{item.received_quantity_formatted}</div>
                            </div>

                            <div className="remaining-quantity like-cell">
                                <div className="cell-label">{window.__js_contracts.remaining_quantity}</div>
                                <div className="cell-value">{item.remaining_quantity_formatted}</div>
                            </div>

                            <div className={"actions like-cell" + (this.props.readonly ? " hidden" : "")}>
                                <div className="cell-label"></div>
                                <div className="cell-value">
                                    <Button onClick={() => this.viewDetails(item.id)}
                                            bsStyle="primary"
                                            bsSize="xsmall">
                                        <i className="fa fa-info-circle"></i> {window.__js_contracts.details}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    );
                }
            }
        }
        else {
            rows.push(
                <div key="0" className="fullwidth-new like-cell">
                    <em>{window.__js_contracts.no_items_found}</em>
                </div>
            );
        }

        let modal = null;
        if (!this.props.readonly) {
            modal = (
                <ContractItemsHistoryModal
                    id={this.state.item_id}
                    contractId={this.props.contractId}
                    showModal={this.state.show_modal}
                    closeCallback={this.closeModal}/>
            );
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div id="contract-items-history-container">
                            <div id="contract-items-history-head" className="like-row like-thead">
                                <div className="description like-cell">{window.__js_contracts.item_description}</div>
                                <div className="measurement-unit like-cell">{window.__js_contracts.measurement_unit}</div>
                                <div className="quantity like-cell">{window.__js_contracts.total_quantity}</div>
                                <div className="received-quantity like-cell">{window.__js_contracts.received_quantity}</div>
                                <div className="remaining-quantity like-cell">{window.__js_contracts.remaining_quantity}</div>
                                <div
                                    className={"actions like-cell" + (this.props.readonly ? " hidden" : "")}>{window.__js_contracts.actions}
                                </div>
                            </div>
                            <div className="like-tbody">
                                {rows}
                            </div>
                        </div>
                    </div>
                </div>
                {modal}
            </div>
        );
    }
}

if (document.getElementById("contract-items-history")) {
    let element = document.getElementById("contract-items-history");
    let csrf_token = element.getAttribute("data-csrf-token");
    let contract_id = element.getAttribute("data-contract-id");
    let readonly = (element.getAttribute("data-readonly") === "1");

    ReactDOM.render(
        <ContractItemsHistory
            csrfToken={csrf_token}
            contractId={contract_id}
            readonly={readonly}/>,
        element
    );
}